<template lang="pug">
div(class="tw-bg-gray-lighten-4 tw-mt-2 tw-overflow-hidden ")
  v-row(align="center")
    v-col(v-if="property.galleries[0].main_image" cols="auto" class=" tw-p-0")
      v-img(:src="path(property.galleries[0].main_image.path)" fill aspect-ratio="2" width="190")
    v-col(class="tw-mx-2 tw-self-start tw-mt-2")
      v-row(dense)
        v-col(class="tw-p-0")
          router-link(class="tw-font-medium text-link tw-capitalize" :to="{ name: 'goodsItem', params: { id: property.id } }") {{ property.name }}
      v-row(dense)
        v-col(class="tw-p-0")
          div(class=" ") {{ property.address_street }}{{ property.address_street_number }}, {{ property.address_city }}
      v-row(dense justify="start" align="end" class="tw-h-full ")
        v-col(cols="auto" class=" tw-px-0 ")
          v-row(no-gutters justify="center" class=" ")
            v-col(v-if="property.bedrooms > 0" class="tw-mr-2")
              v-row(no-gutters align="center" justify="center")
                v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                  span {{ property.bedrooms }}
                v-col(cols="auto" class=" tw-text-center")
                  v-icon mdi-bed
              v-row(no-gutters)
                v-col(cols="auto" class=" tw-text-center tw-text-xs tw-capitalize")
                  | {{ $t('Listings.Common.bedrooms') }}
            v-col(v-if="property.bathrooms > 0" class="tw-mr-2")
              v-row(no-gutters align="center" justify="center")
                v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                  span {{ property.bathrooms }}
                v-col(cols="auto" class=" tw-text-center")
                  v-icon mdi-shower
              v-row(no-gutters)
                v-col(class=" tw-text-center tw-text-xs tw-capitalize")
                  | {{ $t('Listings.Common.bathrooms') }}
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    property() {
      return this.$store.getters['leads/current_lead'].property[0];
    },
  },
};
</script>
